/*
  PostHog for every Clearlight storefront on this theme (spec: docs/POSTHOG.md).
  Project 296824 "Clearlight (all markets)", EU Cloud. One file for both stores.

  Consent (same pattern as Helsi, proven there):
  - undecided or "statistics" refused: cookieless. Nothing is stored on the device,
    PostHog counts with a server-side hash; no person profile, no replay.
  - "statistics" accepted: first-party cookie, person profiles for identified
    leads, session replay (inputs masked), heatmaps.
  Consent source: Cookiebot on the EU store (the Shopify Customer Privacy API there
  does NOT mirror Cookiebot's choice), the Shopify Customer Privacy API elsewhere.

  Performance: the library loads when the browser is idle (max 2.5 s after load);
  every call before that is queued here, so nothing is lost and nothing blocks LCP.
*/
(function () {
  'use strict';
  if (window.clPH) return;

  var cfgEl = document.getElementById('cl-ph-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  // Automation and crawlers are not visitors: no SDK at all (Lighthouse, Playwright, headless, bots).
  var UA = navigator.userAgent || '';
  // "moto g power (2022)" with Android 11 is Lighthouse/PageSpeed's mobile emulation (real Chrome on
  // Android reports the reduced "Android 10; K"); HeadlessChrome shows up in userAgentData brands.
  var brands = ((navigator.userAgentData && navigator.userAgentData.brands) || []).map(function (b) { return b.brand; }).join(' ');
  if (navigator.webdriver || /HeadlessChrome/.test(brands) || /HeadlessChrome|Headless|Lighthouse|Chrome-Lighthouse|moto g power \(2022\)|Playwright|PTST|GTmetrix|bot\b|bot\/|crawler|spider|Google-InspectionTool|AdsBot|Mediapartners/i.test(UA)) return;

  var props = CFG.props || {};
  var themeRole = (window.Shopify && Shopify.theme && Shopify.theme.role) || '';
  props.is_preview = !!(CFG.design_mode || /[?&](preview_theme_id|_ab|_fd)=/.test(location.search) || (themeRole && themeRole !== 'main'));
  props.theme_id = (window.Shopify && Shopify.theme && Shopify.theme.id) || null;
  // BF hero artwork A/B (snippets/cl-ab-hero): the variant rides on every event, so leads split by it.
  (function () {
    var d = document.documentElement;
    var v = d.getAttribute('data-cl-ab-hero') || ((document.cookie.match(/(?:^|; )cl_ab_hero=(a|b)/) || [])[1]);
    if (v && !d.hasAttribute('data-cl-ab-hero-pending')) props.ab_bf_hero = v;
    if (d.getAttribute('data-cl-ab-hero-qa') === '1') props.is_test_traffic = true;
  })();
  (function () {
    var q = new URLSearchParams(location.search);
    var src = (q.get('utm_source') || '').toLowerCase();
    var med = (q.get('utm_medium') || '').toLowerCase();
    var qa = /^(ph-qa|stegaqa)/.test(src) || /^(e2e|e2e-live|test)$/.test(med);
    try {
      if (qa) sessionStorage.setItem('cl_ph_qa', '1');
      if (sessionStorage.getItem('cl_ph_qa') === '1') props.is_test_traffic = true;
    } catch (e) { if (qa) props.is_test_traffic = true; }
  })();

  /* ---------------------------------------------------------------- queue */
  var ph = null;              // the real SDK once loaded
  var queue = [];
  var sawPageview = false;
  var pendingIdentify = [];
  var consentState = { decided: false, analytics: false, source: 'none' };

  function track(event, properties, instant) {
    var p = properties || {};
    if (ph) {
      ph.capture(event, p, instant ? { send_instantly: true, transport: 'sendBeacon' } : undefined);
    } else if (queue.length < 300) {
      queue.push([event, p, instant]);
    }
  }

  /* ------------------------------------------------------------- consent */
  function cookiebotPresent() {
    return !!(window.Cookiebot || document.getElementById('uc-embed-config') || document.getElementById('Cookiebot'));
  }

  function readConsent() {
    if (cookiebotPresent()) {
      var cb = window.Cookiebot;
      if (!cb || !cb.consent) return { decided: false, analytics: false, source: 'cookiebot', ready: false };
      var stamp = String(cb.consent.stamp || '0');
      var decided = !!(cb.hasResponse || (stamp !== '0' && stamp !== '' && stamp !== '-1'));
      return { decided: decided, analytics: decided && !!cb.consent.statistics, source: 'cookiebot', ready: true };
    }
    var cp = window.Shopify && Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
      var allowed = !!cp.analyticsProcessingAllowed();
      var decidedS = true;
      try {
        var cur = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
        var banner = typeof cp.shouldShowBanner === 'function' ? cp.shouldShowBanner() : false;
        decidedS = !banner || !!(cur && cur.analytics);
      } catch (e) { /* older API */ }
      return { decided: decidedS, analytics: allowed, source: 'shopify', ready: true };
    }
    return { decided: false, analytics: false, source: 'none', ready: false };
  }

  function consentLabel(c) { return c.analytics ? 'granted' : (c.decided ? 'denied' : 'pending'); }

  function applyConsent() {
    var c = readConsent();
    var changed = c.analytics !== consentState.analytics || c.decided !== consentState.decided;
    consentState = c;
    if (!ph) return;
    var status = typeof ph.get_explicit_consent_status === 'function' ? ph.get_explicit_consent_status() : null;
    if (c.analytics) {
      if (status !== 'granted') {
        ph.opt_in_capturing({ captureEventName: false });
        // The landing pageview went out cookieless; give the consented identity its own, so the
        // person's funnel (and $initial_* attribution) starts on this page with its UTMs.
        if (sawPageview) ph.capture('$pageview', { consent_transition: true });
      }
      // One $set per person, not per pageview: only when these values change.
      var ppKey = 'cl_ph_pp';
      var ppVal = props.market + '|' + props.store;
      var ppSeen = '';
      try { ppSeen = localStorage.getItem(ppKey) || ''; } catch (e) { /* storage off */ }
      if (ppSeen !== ppVal) {
        ph.setPersonProperties({ analytics_consent: true, market: props.market, store: props.store }, { first_market: props.market, first_store: props.store, first_host: props.site_host });
        try { localStorage.setItem(ppKey, ppVal); } catch (e) { /* storage off */ }
      }
      if (changed) syncCartIdentity(false);
    } else if (c.decided) {
      if (status !== 'denied') ph.opt_out_capturing();
    } else if (status && status !== 'pending' && typeof ph.clear_opt_in_out_capturing === 'function') {
      ph.clear_opt_in_out_capturing();
    }
    ph.register(context());
  }

  function context() {
    var c = {};
    for (var k in props) c[k] = props[k];
    c.consent = consentLabel(consentState);
    c.consent_source = consentState.source;
    return c;
  }

  function watchConsent() {
    ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline', 'CookiebotOnLoad'].forEach(function (n) {
      window.addEventListener(n, applyConsent);
    });
    document.addEventListener('visitorConsentCollected', function () { setTimeout(applyConsent, 0); });
    // The Cookiebot shim on the EU store does not always dispatch its events: compare cheaply.
    var last = '';
    setInterval(function () {
      var c = readConsent();
      var key = c.source + c.decided + c.analytics;
      if (key !== last) { last = key; applyConsent(); }
    }, 1500);
    if (!cookiebotPresent() && window.Shopify && typeof Shopify.loadFeatures === 'function' && !(Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed)) {
      try { Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { applyConsent(); }); } catch (e) { /* ignore */ }
    }
  }

  /* ---------------------------------------------------------------- SDK */

  /* -------------------------------------------- BF hero artwork experiment */
  // PostHog experiment "bf-hero-artwork" (control = current artwork, price = "up to … off" artwork).
  // snippets/cl-ab-hero assigns the variant before first paint, so the SDK is told that value as a flag
  // override instead of evaluating the flag itself: what PostHog counts is what the visitor saw.
  // Exposure fires once per page where the hero test renders (not while EU consent is pending).
  function heroFlag() {
    var KEY = 'bf-hero-artwork';
    var v = props.ab_bf_hero;
    if (!v || !ph) return;
    var val = v === 'b' ? 'price' : 'control';
    var o = {}; o[KEY] = val;
    try {
      if (ph.featureFlags && typeof ph.featureFlags.overrideFeatureFlags === 'function') ph.featureFlags.overrideFeatureFlags({ flags: o });
      else if (ph.featureFlags && typeof ph.featureFlags.override === 'function') ph.featureFlags.override(o);
    } catch (e) { /* older SDK: the $feature/ property below still carries it */ }
    var reg = {}; reg['$feature/' + KEY] = val;
    ph.register(reg);
    var d = document.documentElement;
    if (d.hasAttribute('data-cl-ab-hero') && !d.hasAttribute('data-cl-ab-hero-pending')) {
      ph.capture('$feature_flag_called', { $feature_flag: KEY, $feature_flag_response: val });
    }
  }

  function loadSDK() {
    /* Official posthog-js loader stub (array.js), EU assets host. */
    !function (t, e) { var o, n, p, r; e.__SV || (window.posthog = e, e._i = [], e.init = function (i, s, a) { function g(t, e) { var o = e.split('.'); 2 == o.length && (t = t[o[0]], e = o[1]), t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } } (p = t.createElement('script')).type = 'text/javascript', p.crossOrigin = 'anonymous', p.async = !0, p.src = s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js', (r = t.getElementsByTagName('script')[0]).parentNode.insertBefore(p, r); var u = e; for (void 0 !== a ? u = e[a] = [] : a = 'posthog', u.people = u.people || [], u.toString = function (t) { var e = 'posthog'; return 'posthog' !== a && (e += '.' + a), t || (e += ' (stub)'), e }, u.people.toString = function () { return u.toString(1) + '.people (stub)' }, o = 'init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status clear_opt_in_out_capturing debug'.split(' '), n = 0; n < o.length; n++)g(u, o[n]); e._i.push([i, s, a]) }, e.__SV = 1) }(document, window.posthog || []);

    window.posthog.init(CFG.token, {
      api_host: CFG.api_host,
      ui_host: CFG.ui_host,
      defaults: '2026-05-30',
      cookieless_mode: 'on_reject',
      opt_out_capturing_by_default: true,
      consent_persistence_name: 'cl_ph_consent',
      person_profiles: 'identified_only',
      persistence: 'localStorage+cookie',
      capture_pageview: false,          // sent below, once consent is known
      capture_pageleave: true,
      capture_exceptions: true,
      capture_dead_clicks: true,
      capture_heatmaps: true,
      capture_performance: { web_vitals: true, network_timing: true },
      // Day-1 review: $autocapture was 23% of all events and duplicated CTA Clicked. The free tier
      // (1M events/month, hard stop) has to carry Black Friday, so clicks are custom events only.
      autocapture: false,
      rageclick: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-ph-mask], .ph-mask, input, textarea',
        recordCrossOriginIframes: false
      },
      // Off on purpose: it masks gclid/fbclid/msclkid, which the lead attribution needs. No PII
      // goes into URLs or event properties here (emails only as the identify id, after consent).
      mask_personal_data_properties: false,
      internal_or_test_user_hostname: /^(localhost|127\.0\.0\.1)$|myshopify\.com$|shopifypreview\.com$/,
      custom_campaign_params: ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'li_fat_id', 'srsltid', 'hsa_cam', '_hsenc', 'kl_campaign'],
      before_send: function (event) {
        if (!event) return event;
        if (event.event === '$exception' && noiseException(event)) return null;
        if (event.event === '$web_vitals' && !sampled(0.15)) return null;
        if (event.event === '$dead_swipe') return null;
        if (event.event === '$pageview') sawPageview = true;
        var base = context();
        var p = event.properties || {};
        for (var k in base) if (!(k in p)) p[k] = base[k];
        event.properties = p;
        return event;
      },
      loaded: function (instance) {
        ph = instance;
        heroFlag();
        applyConsent();
        // Wait (briefly) for the consent banner so the landing pageview carries the right mode.
        var waited = 0;
        (function sendFirst() {
          var c = readConsent();
          if (!c.ready && waited < 2000) { waited += 250; return setTimeout(sendFirst, 250); }
          applyConsent();
          if (!sawPageview) ph.capture('$pageview');
          pendingIdentify.splice(0).forEach(function (fn) { try { fn(); } catch (e) { /* ignore */ } });
          try { sessionStorage.removeItem('cl_ph_lead_pending'); } catch (x) { /* storage off */ }
          var q = queue.splice(0);
          for (var i = 0; i < q.length; i++) {
            ph.capture(q[i][0], q[i][1], q[i][2] ? { send_instantly: true, transport: 'sendBeacon' } : undefined);
          }
        })();
      }
    });
  }

  // Cross-origin third-party scripts report as "Script error." with no stack; known vendor noise too.
  var NOISE = /^Script error\.?$|Goaffpro is already loaded|uetq|webkit\.messageHandlers|Java object is gone|play\(\) request was interrupted|fbq is not defined|ResizeObserver loop|Load failed|NetworkError when attempting|Network Error|network failure may have prevented/i;
  function noiseException(ev) {
    var p = ev.properties || {};
    var vals = [].concat(p.$exception_values || [], p.$exception_message || []).join(' | ');
    if (NOISE.test(vals)) return true;
    var list = p.$exception_list || [];
    // keep only errors with a first-party frame (theme assets or the page itself)
    var frames = [];
    list.forEach(function (x) { ((x.stacktrace || {}).frames || []).forEach(function (f) { frames.push(f.filename || f.abs_path || ''); }); });
    if (frames.length && !frames.some(function (f) { return f.indexOf(location.host) > -1 || /cdn\/shop\/t\/|\/assets\//.test(f); })) return true;
    return false;
  }
  // Stable per-session sampling, so a sampled session keeps all its vitals.
  function sampled(rate) {
    var sid = (ph && ph.get_session_id && ph.get_session_id()) || '';
    var h = 0;
    for (var i = 0; i < sid.length; i++) h = (h * 31 + sid.charCodeAt(i)) >>> 0;
    return sid ? (h % 1000) / 1000 < rate : Math.random() < rate;
  }

  function whenIdle(fn) {
    var done = false;
    function run() { if (done) return; done = true; fn(); }
    function schedule() {
      if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2500 });
      else setTimeout(run, 1200);
      setTimeout(run, 2500);
    }
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
    // A visitor who leaves or acts before idle still gets counted.
    ['pointerdown', 'keydown', 'scroll'].forEach(function (n) { addEventListener(n, function () { setTimeout(run, 400); }, { once: true, passive: true }); });
    addEventListener('pagehide', run, { once: true });
  }

  /* ------------------------------------------------------------ helpers */
  function text(el, max) {
    var t = (el && (el.getAttribute('aria-label') || el.textContent) || '').replace(/\s+/g, ' ').trim();
    return t.length > (max || 80) ? t.slice(0, max || 80) : t;
  }

  function pathOf(href) {
    try { return new URL(href, location.href); } catch (e) { return null; }
  }

  function locationOf(el) {
    var tagged = el.closest('[data-ph-location]');
    if (tagged) return tagged.getAttribute('data-ph-location');
    var rules = [
      ['campaign_bar', '[data-cl-campaign-bar]'],
      ['campaign_hero', '[data-cl-campaign-hero]'],
      ['campaign_band', '[data-cl-campaign-band]'],
      ['bf_card', '[data-cl-bf]'],
      ['tray', '.cl-cmp-tray, [data-cl-cmp-tray]'],
      ['pdp_sticky', '[class*="cl-product__sticky"]'],
      ['nav', 'header, .cl-nav, [class*="cl-topbar"], nav'],
      ['footer', 'footer, .cl-footer'],
      ['pdp_buybox', '.cl-product [class*="buy"], .cl-product__info, .cl-product__aside'],
      ['card', '[class*="cl-card"], [class*="product-card"], [class*="cl-cards"]'],
      ['hero', '.cl-hero, .cl-page-hero, [class*="cl-hsform-hero"], [class*="hero"]'],
      ['quiz', '.cl-quiz'],
      ['faq', '.cl-faq'],
      ['form', '.cl-contact-form']
    ];
    for (var i = 0; i < rules.length; i++) if (el.closest(rules[i][1])) return rules[i][0];
    return 'body';
  }

  function sectionOf(el) {
    var s = el.closest('[id^="shopify-section-"]');
    return s ? s.id.replace('shopify-section-', '') : '';
  }

  var RX = {
    pricing: /\/pages\/(get-clearlight-pricing|get-pricing|request-pricing|contact-us|preisanfrage|preise?-?anfrag|infrarotkabine-fuer-zuhause|unlock-best-price|pricing)\b|#cl-form-(pricing|preis)/i,
    pricingText: /jetzt anfragen|request a quote|get a quote|request (personali[sz]ed )?pric|get (your )?pric|view pric|price list|claim (your )?offer|preis(e|liste)? (anfordern|anfragen|ansehen)|infos? (&|und) preise|informationen anfordern|angebot anfordern|preisliste/i,
    ebook: /\/pages\/(ebook|e-book)[^"]*/i,
    call: /\/pages\/(book-a-call|beratung|termin|book-call|kontakt-beratung)|#cl-form-beratung/i,
    callText: /book a (free )?(call|consult)|beratung (buchen|vereinbaren)|termin (buchen|vereinbaren)|r(ü|ue)ckruf/i,
    compare: /\/pages\/(compare-saunas|saunen-vergleichen)/i,
    finance: /zopa|dividebuy|finanz|financ/i,
    quiz: /sauna-finder|quiz/i,
    commercial: /\/pages\/(commercial-saunas|gewerbliche-infrarotkabinen|gewerb|commercial)/i,
    contact: /\/pages\/(contact|kontakt|make-an-enquiry)/i
  };

  function classify(a) {
    var forced = a.getAttribute('data-ph-cta');
    var href = a.getAttribute('href') || '';
    var label = text(a);
    if (forced) return forced;
    // Market/language switchers and filter controls are UI, not calls to action.
    if (a.closest('form[action*="/localization"], [data-cl-localization], .cl-localization, [class*="locali"], [class*="country-selector"], [class*="lang-switch"]')) return '';
    if (/^(wechseln|switch|apply selection|auswahl (übernehmen|anwenden)|lietot atlasi|change|ändern)$/i.test(label)) return '';
    if (/^tel:/i.test(href)) return 'phone';
    if (/^mailto:/i.test(href)) return 'email';
    if (/wa\.me|whatsapp/i.test(href)) return 'whatsapp';
    if (/\.pdf(\?|$)/i.test(href)) return 'spec_sheet';
    if (RX.pricing.test(href) || RX.pricingText.test(label)) return 'request_pricing';
    if (RX.call.test(href) || RX.callText.test(label)) return 'book_call';
    if (RX.compare.test(href) || a.matches('[data-cl-cmp-tray-go], [data-cl-compare-open]')) return 'compare';
    if (RX.quiz.test(href)) return 'quiz';
    if (RX.ebook.test(href)) return 'ebook';
    if (RX.finance.test(href)) return 'finance';
    if (RX.commercial.test(href)) return 'commercial';
    if (RX.contact.test(href) || /^(contact|kontakt)$/i.test(label)) return 'contact';
    if (/^#|shopify-section-/.test(href) || /↓|entdecken|discover the|explore/i.test(label)) return 'explore';
    if (/testimonial|kundenbewertung|reviews?\b|bewertungen/i.test(label) || /\/pages\/(reviews|bewertungen)/i.test(href)) return 'reviews';
    if (/\/collections\//i.test(href) || /^(modelle ansehen|view models?|alle modelle|shop now|zu den modellen)$/i.test(label)) return 'browse_models';
    if (/\/products\//i.test(href) || /^(view model|modell ansehen|details)$/i.test(label)) return 'view_product';
    if (/^(suchen|search)$/i.test(label)) return 'search';
    if (/check ?out|zur kasse/i.test(label)) return 'checkout';
    if (a.matches('.button, [class*="cta"], [class*="__go"]')) return 'other';
    return '';
  }

  /* -------------------------------------------------------------- clicks */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href], button, [data-ph-cta]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var cta = classify(a);
    var loc = locationOf(a);

    if (cta) {
      var u = href ? pathOf(href) : null;
      track('CTA Clicked', {
        cta: cta,
        location: loc,
        label: text(a),
        destination: u ? (u.host === location.host ? u.pathname + u.hash : u.host + u.pathname) : '',
        section: sectionOf(a)
      }, true);
    }
    if (cta === 'phone' || cta === 'email' || cta === 'whatsapp') track('Contact Clicked', { channel: cta, location: loc }, true);
    if (cta === 'spec_sheet' || a.hasAttribute('download')) {
      var f = (pathOf(href) || {}).pathname || href;
      var bf = a.getAttribute('data-cl-bf');
      var isPriceList = bf === 'ty-pricelist' || /preisliste|price[-_ ]?list|pricelist/i.test(f + ' ' + text(a));
      track(isPriceList ? 'Price List Requested' : 'Spec Sheet Downloaded', {
        file: f.split('/').pop(),
        product_handle: CFG.product ? CFG.product.product_handle : null,
        location: loc,
        campaign: isPriceList ? 'bf2026' : undefined
      }, true);
    }
    if (a.matches('[data-cl-video-open], [data-cl-video], [aria-controls*="video"]')) {
      track('Video Played', { video: a.getAttribute('data-cl-video-open') || a.getAttribute('data-cl-video') || text(a, 60), location: loc, trigger: 'click' });
    }
    if (a.matches('[data-cl-quiz-start], [data-cl-quiz-answer]')) quizStart();

    // Checkout (EU store; the UK store has no cart)
    if (a.matches('[name="checkout"], a[href*="/checkout"]')) checkoutStarted(loc);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (/\/search/.test(action)) {
      var q = form.querySelector('[name="q"]');
      track('Search Submitted', { query_length: q ? q.value.trim().length : 0, location: locationOf(form) });
    } else if (/\/cart\/add/.test(action) && !form.hasAttribute('data-ph-js-cart')) {
      productAddedFromForm(form);
    } else if (/\/checkout/.test(action) || form.querySelector('[name="checkout"]:focus')) {
      checkoutStarted(locationOf(form));
    } else if (form.matches('.cl-contact-form__form, form[action*="/contact"]')) {
      // Validation, the honeypot and the HubSpot-forward path all preventDefault: those are
      // either not a lead or are caught at the HubSpot response (fetch hook). A plain post
      // reloads with ?contact_posted=true, where the lead is counted (see pageEvents).
      var ev = e;
      setTimeout(function () {
        if (ev.defaultPrevented) return;
        var em = form.querySelector('[type="email"], [name*="email" i]');
        var stash = {
          form_id: 'native:' + (form.id || sectionOf(form)),
          form_variant: (form.querySelector('[name*="Kundentyp"]:checked') || {}).value || '',
          form_location: location.pathname,
          section: sectionOf(form),
          provider: 'shopify'
        };
        if (consentState.analytics) {
          try { stash.email = em ? em.value : ''; sessionStorage.setItem('cl_ph_lead', JSON.stringify(stash)); } catch (x) { /* storage off */ }
        }
      }, 0);
    }
  }, true);

  /* --------------------------------------------------------------- leads */
  var leadSeen = {};
  var meetingAt = 0;
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function gaClientId() {
    var v = cookie('_ga');            // GA1.1.<random>.<timestamp>
    var parts = v.split('.');
    return parts.length >= 4 ? parts.slice(-2).join('.') : '';
  }
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'li_fat_id'];
  function clickIds() {
    var q = new URLSearchParams(location.search);
    var out = {};
    CLICK_IDS.forEach(function (k) { if (q.get(k)) out[k] = q.get(k); });
    return out;
  }

  function leadSubmitted(p, email) {
    var key = (p.form_id || 'form') + '|' + location.pathname;
    var now = Date.now();
    if (leadSeen[key] && now - leadSeen[key] < 8000) {
      // Same submission reported by a second embed path: count once, but keep its email.
      if (email) identifyLead(email, p.form_id, p);
      return;
    }
    leadSeen[key] = now;
    p.location = p.location || p.form_location;
    if (consentState.analytics) {
      // Device identifiers only with consent; cookieless leads stay anonymous counts.
      p.hubspot_utk = cookie('hubspotutk') || null;
      p.ga_client_id = gaClientId() || null;
      var ids = clickIds();
      for (var k in ids) p[k] = ids[k];
    }
    p.has_email = !!email;
    if (consentState.analytics) { try { sessionStorage.setItem('cl_ph_lead_at', String(now)); } catch (x) { /* storage off */ } }
    if (!ph && consentState.analytics) {
      // The form may navigate away before the SDK has loaded: hand the lead to the next page.
      try { sessionStorage.setItem('cl_ph_lead_pending', JSON.stringify(p)); } catch (x) { /* storage off */ }
    }
    track('Lead Submitted', p, true);
    identifyLead(email, p.form_id, p);
  }

  function identifyLead(email, formId, lead) {
    email = String(email || '').trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    lead = lead || {};
    function go() {
      if (!consentState.analytics) return;   // cookieless leads stay anonymous, no PII
      var set = { email: email, market: props.market, store: props.store, site_host: props.site_host, last_lead_form: formId, last_lead_at: new Date().toISOString() };
      if (cookie('hubspotutk')) set.hubspot_utk = cookie('hubspotutk');
      if (gaClientId()) set.ga_client_id = gaClientId();
      var once = { first_lead_form: formId, first_lead_market: props.market, first_lead_page: location.pathname, first_lead_at: set.last_lead_at, first_lead_bf_phase: props.bf_phase };
      CLICK_IDS.forEach(function (k) { if (lead[k]) once['first_' + k] = lead[k]; });
      ph.identify(email, set, once);
    }
    if (ph) go(); else pendingIdentify.push(go);
  }

  var COMMERCIAL_FORMS = /^(29c8a7af|29b8c533)/;
  function formMeta(el, formId) {
    var pane = el && el.closest ? el.closest('[data-cl-hs-pane]') : null;
    var modal = el && el.closest ? el.closest('dialog, [data-stega-hs-modal], .stega-hs-modal') : null;
    var variant = pane ? pane.getAttribute('data-cl-hs-pane') : (el && el.getAttribute && el.getAttribute('data-ph-variant')) || '';
    if (!variant) variant = modal ? 'claim_offer_modal' : (COMMERCIAL_FORMS.test(formId || '') ? 'commercial' : 'private');
    return {
      form_id: formId || '',
      form_variant: variant,
      form_location: location.pathname,
      section: el ? sectionOf(el) : '',
      provider: 'hubspot'
    };
  }

  function frameFor(formId) {
    if (!formId) return null;
    return document.querySelector('.hs-form-frame[data-form-id="' + formId + '"], [data-cl-hs-legacy="' + formId + '"]');
  }

  // HubSpot v4 embeds ("hs-form-frame")
  window.addEventListener('hs-form-event:on-submission:success', function (e) {
    var formId = '';
    var form = null;
    try {
      form = window.HubSpotFormsV4 && HubSpotFormsV4.getFormFromEvent ? HubSpotFormsV4.getFormFromEvent(e) : null;
      formId = (e.detail && (e.detail.formId || e.detail.formGuid)) || (form && form.getFormId && form.getFormId()) || '';
    } catch (err) { /* ignore */ }
    var meta = formMeta(frameFor(formId), formId);
    // Count first (the form may redirect right away), identify when the values resolve.
    leadSubmitted(meta, '');
    if (form && form.getFormFieldValues) {
      form.getFormFieldValues().then(function (vals) {
        var email = '';
        (vals || []).forEach(function (v) { if (/email/i.test(v.name || '') && !email) email = v.value; });
        identifyLead(email, formId, meta);
      }).catch(function () { /* values unavailable */ });
    }
  });

  // HubSpot v2 (legacy editor) callbacks arrive as window messages
  window.addEventListener('message', function (e) {
    var d = e.data;
    if (!d || typeof d !== 'object') return;
    // HubSpot CTA pop-ups (legacy "Get a Quote" CTAs on the campaign pages) post this on submit.
    if (d.type === 'hsCallsToActionCallback' && d.eventName === 'onCallToActionFormSubmitted') {
      var cid = (d.data && (d.data.formId || d.data.formGuid)) || '';
      var cm = formMeta(null, cid);
      cm.form_variant = 'hubspot_cta_popup';
      cm.provider = 'hubspot_cta';
      var cmail = '';
      var csv = d.data && (d.data.submissionValues || d.data.values);
      if (csv && csv.email) cmail = csv.email;
      leadSubmitted(cm, cmail);
      return;
    }
    if (d.type === 'hsFormCallback') {
      var id = d.id || '';
      if (d.eventName === 'onFormReady') formStarted(frameFor(id), id, 'ready');
      if (d.eventName === 'onFormSubmitted' || d.eventName === 'onFormSubmit') {
        if (d.eventName === 'onFormSubmit') return; // wait for the confirmed submission
        var email = '';
        var sv = d.data && (d.data.submissionValues || d.data);
        if (sv && sv.email) email = sv.email;
        if (Array.isArray(sv)) sv.forEach(function (x) { if (x && x.name === 'email') email = x.value; });
        leadSubmitted(formMeta(frameFor(id), id), email);
      }
    }
    // HubSpot meetings embed
    if (d.meetingBookSucceeded || (d.type && /meeting.*book.*succe/i.test(String(d.type)))) {
      var origin = String(e.origin || '');
      if (!/hubspot|hs-sites|hsforms/i.test(origin)) return;
      if (Date.now() - meetingAt < 8000) return;
      meetingAt = Date.now();
      var payload = d.meetingsPayload || {};
      track('Meeting Booked', {
        meeting_link: payload.bookingResponse && payload.bookingResponse.event ? payload.bookingResponse.event.meetingLinkId || '' : '',
        form_location: location.pathname,
        location: 'meetings_embed'
      }, true);
      var mail = payload.bookingResponse && payload.bookingResponse.postResponse && payload.bookingResponse.postResponse.contact
        ? payload.bookingResponse.postResponse.contact.email : '';
      if (mail) identifyLead(mail, 'meeting');
    }
  });

  // "Lead Form Started": focus moves into a HubSpot iframe (window blur), or a native field
  var started = {};
  function formStarted(el, formId, how) {
    var key = formId || (el && el.id) || 'form';
    if (started[key] || how === 'ready') return;
    started[key] = 1;
    var m = formMeta(el, formId);
    m.how = how;
    track('Lead Form Started', m);
  }
  window.addEventListener('blur', function () {
    setTimeout(function () {
      var f = document.activeElement;
      if (!f || f.tagName !== 'IFRAME') return;
      var host = f.closest('.hs-form-frame, [data-cl-hs-legacy], .hbspt-form');
      if (host) formStarted(host, host.getAttribute('data-form-id') || host.getAttribute('data-cl-hs-legacy') || '', 'iframe_focus');
    }, 0);
  });
  document.addEventListener('focusin', function (e) {
    var form = e.target.closest && e.target.closest('.cl-contact-form__form');
    if (form) formStarted(form, 'native:' + (form.id || sectionOf(form)), 'focus');
  });

  /* ----------------------------------------------------- in-view events */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      io.unobserve(el);
      var kind = el.getAttribute('data-ph-view');
      if (kind === 'form') {
        var fid = el.getAttribute('data-form-id') || el.getAttribute('data-cl-hs-legacy') || ('native:' + (el.id || sectionOf(el)));
        var m = formMeta(el, fid);
        m.provider = el.matches('.cl-contact-form__form') ? 'shopify' : 'hubspot';
        track('Lead Form Viewed', m);
      } else if (kind === 'campaign') {
        track('Campaign Viewed', {
          campaign: 'bf2026',
          block: el.hasAttribute('data-cl-campaign-bar') ? 'bar' : el.hasAttribute('data-cl-campaign-hero') ? 'hero' : el.hasAttribute('data-cl-campaign-band') ? 'band' : (el.getAttribute('data-cl-bf') || 'other'),
          bf_phase: el.getAttribute('data-phase') || props.bf_phase,
          location: locationOf(el)
        });
      }
    });
  }, { threshold: 0.5 }) : null;

  function observe() {
    if (!io) return;
    document.querySelectorAll('.hs-form-frame, [data-cl-hs-legacy], .cl-contact-form__form').forEach(function (el) {
      if (el.hasAttribute('data-ph-view')) return;
      el.setAttribute('data-ph-view', 'form');
      io.observe(el);
    });
    document.querySelectorAll('[data-cl-campaign-bar], [data-cl-campaign-hero], [data-cl-campaign-band], [data-cl-bf="card"], [data-cl-bf="badge"]').forEach(function (el) {
      if (el.hasAttribute('data-ph-view')) return;
      el.setAttribute('data-ph-view', 'campaign');
      io.observe(el);
    });
  }

  /* ---------------------------------------------------------------- media */
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO') return;
    // Background films autoplay muted: only plays a person started count.
    if (v.muted && (v.autoplay || v.loop || v.hasAttribute('data-cl-hs-video') || v.hasAttribute('data-cl-hero-video'))) return;
    if (v.__phPlayed) return;
    v.__phPlayed = 1;
    track('Video Played', { video: (v.currentSrc || '').split('/').pop().split('?')[0], location: locationOf(v), trigger: 'play' });
  }, true);

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var s = d.querySelector('summary');
    track('FAQ Opened', { question: text(s, 120), location: locationOf(d), section: sectionOf(d) });
  }, true);

  /* ----------------------------------------------------------------- quiz */
  var quizStarted = false;
  function quizStart() {
    if (quizStarted) return;
    quizStarted = true;
    track('Quiz Started', { location: locationOf(document.querySelector('.cl-quiz') || document.body) });
  }
  function watchQuiz() {
    var name = document.querySelector('[data-cl-quiz-top-name]');
    if (!name || !('MutationObserver' in window)) return;
    var sent = false;
    new MutationObserver(function () {
      var t = text(name, 80);
      if (!t || sent) return;
      sent = true;
      var steps = document.querySelectorAll('[data-cl-quiz-panel].is-step').length;
      track('Quiz Completed', { recommended_model: t, steps: steps });
    }).observe(name, { childList: true, characterData: true, subtree: true });
  }

  /* ------------------------------------------------------------ commerce */
  function money(v) { return typeof v === 'number' ? v / 100 : null; }

  function productAddedFromItem(item, loc) {
    track('Product Added', {
      product_id: item.product_id,
      variant_id: item.variant_id || item.id,
      product_handle: item.handle,
      product_title: item.product_title || item.title,
      price: money(item.final_price != null ? item.final_price : item.price),
      quantity: item.quantity || 1,
      value: money(item.final_line_price != null ? item.final_line_price : item.line_price),
      currency: props.currency,
      location: loc || 'unknown'
    });
  }

  function productAddedFromForm(form) {
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    track('Product Added', {
      variant_id: id ? Number(id.value) : null,
      product_handle: CFG.product ? CFG.product.product_handle : null,
      quantity: qty ? Number(qty.value) || 1 : 1,
      currency: props.currency,
      location: locationOf(form)
    });
    syncCartIdentity(true);
  }

  // Store mode commerce (ANZ): the cart page's value and counts ride on Cart Viewed and Checkout
  // Started (CFG.cart from cl-posthog.liquid, kept current by cl-commerce.js after a quantity change).
  // Lead stores have no CFG.cart, so their properties are unchanged.
  function cartProps(base) {
    if (!CFG.cart) {
      var cd = document.querySelector('[data-cl-cd-inner]');
      if (cd && cd.closest('dialog[open]')) {
        base.value = (Number(cd.getAttribute('data-cl-cd-total')) || 0) / 100;
        base.items_count = Number(cd.getAttribute('data-cl-cd-count')) || 0;
        base.lines_count = Number(cd.getAttribute('data-cl-cd-lines')) || 0;
      }
      return base;
    }
    for (var k in CFG.cart) if (Object.prototype.hasOwnProperty.call(CFG.cart, k)) base[k] = CFG.cart[k];
    return base;
  }
  // Cart drawer (store mode commerce, sections/cl-cart-drawer): opening it is a cart view.
  document.addEventListener('cl:cart-viewed', function (e) {
    var d = e.detail || {};
    track('Cart Viewed', { currency: props.currency, location: d.location || 'drawer', value: d.value, items_count: d.items_count, lines_count: d.lines_count });
  });
  document.addEventListener('cl:cart-updated', function (e) {
    var c = e.detail;
    if (!c || !CFG.cart) return;
    CFG.cart = { value: money(c.total_price), items_count: c.item_count, lines_count: (c.items || []).length };
  });

  var lastCheckout = 0;
  function checkoutStarted(loc) {
    if (Date.now() - lastCheckout < 3000) return;
    lastCheckout = Date.now();
    syncCartIdentity(true);
    track('Checkout Started', cartProps({ location: loc, currency: props.currency }), true);
  }

  // Stitch the order to the visitor: cart attributes the order sync reads back.
  var synced = '';
  // Stores that sell online (EU, ANZ); the UK store has no cart.
  function syncCartIdentity(force) {
    if (props.store === 'uk' || !ph || !consentState.analytics) return null;
    var did = ph.get_distinct_id && ph.get_distinct_id();
    var sid = ph.get_session_id && ph.get_session_id();
    if (!did) return null;
    var key = did + '|' + sid;
    if (key === synced) return null;
    if (!force && !(window.Shopify && document.cookie.indexOf('cart=') > -1)) return null; // never create a cart just for this
    synced = key;
    try {
      return rawFetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _ph_distinct_id: did, _ph_session_id: sid || '' } })
      }).catch(function () { synced = ''; });
    } catch (e) { synced = ''; return null; }
  }

  // Product-page add to cart through /cart/add.js (cl-product.js): the line comes back
  // in full, and the page waits (max 800 ms) for the cart identity before going to /cart.
  document.addEventListener('cl:cart-added', function (e) {
    var d = e.detail || {};
    if (d.item) productAddedFromItem(d.item, d.form ? locationOf(d.form) : 'pdp');
    d.wait = syncCartIdentity(true);
  });

  var rawFetch = window.fetch ? window.fetch.bind(window) : null;
  if (rawFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = rawFetch(input, init);
      var hs = url.match(/hsforms\.com\/submissions\/v3\/integration\/submit\/\d+\/([0-9a-f-]{36})/i);
      if (hs) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          var email = '';
          try {
            var body = JSON.parse(init && init.body ? init.body : '{}');
            (body.fields || []).forEach(function (f) { if (/email/i.test(f.name || '') && !email) email = f.value; });
          } catch (x) { /* not JSON */ }
          var el = document.activeElement && document.activeElement.closest ? document.activeElement.closest('form') : null;
          var m = formMeta(el, hs[1]);
          m.provider = 'hubspot_api';
          leadSubmitted(m, email);
        }).catch(function () { /* network */ });
      }
      if (props.store === 'eu' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (data) {
            var items = data && data.items ? data.items : (data && data.id ? [data] : []);
            var loc = document.activeElement ? locationOf(document.activeElement) : 'unknown';
            items.forEach(function (it) { productAddedFromItem(it, loc); });
            syncCartIdentity(true);
          }).catch(function () { /* not JSON */ });
        }).catch(function () { /* network */ });
      }
      return p;
    };
  }

  /* ---------------------------------------------------------- page level */
  function pageEvents() {
    // A lead counted on the previous page just before it navigated away (SDK not loaded yet).
    try {
      var pend = JSON.parse(sessionStorage.getItem('cl_ph_lead_pending') || 'null');
      sessionStorage.removeItem('cl_ph_lead_pending');
      if (pend && pend.form_id) { pend.recovered = true; leadSubmitted(pend, ''); }
    } catch (x) { /* storage off */ }
    if (CFG.product) track('Product Viewed', CFG.product);
    if (CFG.collection) track('Product List Viewed', CFG.collection);
    if (CFG.search) track('Search Results Viewed', CFG.search);
    if (props.page_type === 'cart') { track('Cart Viewed', cartProps({ currency: props.currency })); }
    if (RX.compare.test(location.pathname)) {
      var models = (new URLSearchParams(location.search).get('models') || '').split(',').filter(Boolean);
      if (models.length) track('Compare Used', { models: models, models_count: models.length, location: 'compare_page' });
    }
    if (/thank|danke|vielen-dank/i.test(location.pathname)) {
      var ref = pathOf(document.referrer);
      var refPath = (ref || {}).pathname || '';
      var leadAt = 0;
      try { leadAt = Number(sessionStorage.getItem('cl_ph_lead_at') || 0); } catch (x) { /* storage off */ }
      var recent = leadAt && Date.now() - leadAt < 30 * 60 * 1000;
      track('Thank You Page Viewed', { referrer_path: refPath, lead_recorded: !!recent });
      // A redirecting form can navigate before its success callback reaches us. With consent we
      // know whether this session already counted the lead; if not, count it here (once).
      // Only a page on this site that redirected here can be such a form: meeting links, emails,
      // search results, direct visits and reloads land on thank-you pages without a new lead.
      var fromForm = !!ref && ref.host === location.host && !/thank|danke/i.test(refPath);
      if (!recent && fromForm && /\/pages\//.test(location.pathname)) {
        whenConsentKnown(function () {
          if (!consentState.analytics) return;
          leadSubmitted({ form_id: 'thank_you_page', form_variant: 'redirect', form_location: refPath || location.pathname, provider: 'thank_you_backfill' }, '');
        });
      }
    }
    if (/[?&]contact_posted=true/.test(location.search)) {
      var st = null;
      try { st = JSON.parse(sessionStorage.getItem('cl_ph_lead') || 'null'); sessionStorage.removeItem('cl_ph_lead'); } catch (x) { /* storage off */ }
      var em = st && st.email; if (st) delete st.email;
      leadSubmitted(st || { form_id: 'native:contact', form_location: location.pathname, provider: 'shopify' }, em || '');
    }
    observe();
    watchQuiz();
    if ('MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(observe, 400); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  function whenConsentKnown(fn) {
    var tries = 0;
    (function wait() {
      var c = readConsent();
      if (c.ready || tries > 12) { consentState = c; return fn(); }
      tries++; setTimeout(wait, 250);
    })();
  }

  /* ------------------------------------------------- BF price A/B test */
  // Flag "bf-lp-price-visibility" (control = prices hidden as today, show = BF price rows visible).
  // snippets/cl-ab-bf-price sets html.cl-abv-show before paint from the cl_ab_bfprice cookie, so a
  // returning visitor never flickers. First-time visitors resolve here once the flag loads; the
  // price block sits far below the hero, so the class lands before it is ever on screen. If the
  // block was already in view, the page keeps what it showed and that view is not counted.
  // Exposure ($feature_flag_called) only fires when the block is in view and shows the flag's variant.
  // No analytics consent = no persistent assignment = control and excluded (no exposure).
  function bfPriceAB() {
    var KEY = 'bf-lp-price-visibility', CK = 'cl_ab_bfprice';
    var root = document.documentElement;
    var block = document.querySelector('[data-ph-ab-block="' + KEY + '"]');
    if (!block) return;
    var qa = root.getAttribute('data-cl-ab-qa') === '1';
    if (qa) { props.is_test_traffic = true; }
    var flagV = null, inView = false, exposed = false, frozen = false;
    function shown() { return root.classList.contains('cl-abv-show') ? 'show' : 'control'; }
    function setCookie(v) {
      if (v) document.cookie = CK + '=' + v + '; path=/; max-age=' + 60 * 60 * 24 * 90 + '; SameSite=Lax';
      else document.cookie = CK + '=; path=/; max-age=0; SameSite=Lax';
    }
    function apply(v) {
      if (frozen) return;
      if (v === 'show') root.classList.add('cl-abv-show'); else root.classList.remove('cl-abv-show');
      root.setAttribute('data-cl-abv', v || 'control');
    }
    function expose() {
      if (exposed || !inView || !flagV || !ph || !consentState.analytics) return;
      if (shown() !== flagV) return;
      exposed = true;
      ph.capture('$feature_flag_called', { $feature_flag: KEY, $feature_flag_response: flagV, ab_qa_override: qa || undefined });
    }
    function resolve() {
      if (!ph) return;
      if (qa) { flagV = root.getAttribute('data-cl-abv') || 'control'; ph.register({ is_test_traffic: true }); expose(); return; }
      if (!consentState.analytics) { flagV = null; setCookie(''); if (!inView) apply(''); return; }
      var v = ph.getFeatureFlag(KEY, { send_event: false });
      if (v === 'show' || v === 'control') {
        flagV = v; setCookie(v);
        if (!inView || shown() === v) apply(v); else frozen = true;
      } else if (v !== undefined) {
        flagV = null; setCookie(''); if (!inView) apply('');
      }
      expose();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es, obs) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          inView = true;
          if (!flagV && !qa && !root.getAttribute('data-cl-abv')) frozen = true;
          expose();
          if (exposed) obs.disconnect();
        });
      }, { threshold: 0.25 }).observe(block);
    }
    var tries = 0;
    (function wait() {
      if (ph) {
        if (props.market) try { ph.setPersonPropertiesForFlags({ market: props.market, store: props.store }); } catch (e) { /* old sdk */ }
        if (typeof ph.onFeatureFlags === 'function') ph.onFeatureFlags(resolve);
        resolve();
        ['CookiebotOnAccept', 'CookiebotOnDecline'].forEach(function (n) { window.addEventListener(n, function () { setTimeout(resolve, 300); }); });
        document.addEventListener('visitorConsentCollected', function () { setTimeout(resolve, 300); });
        return;
      }
      if (tries++ < 60) setTimeout(wait, 500);
    })();
  }

  // Flag "post-enquiry-variant" (control = A info only, add-to-cart = B), the post-enquiry page
  // (template page.post-enquiry on /pages/danke). snippets/cl-pe-ab applies the cl_pe cookie (a|b)
  // before paint; this resolves the flag, writes the cookie only with analytics consent, switches
  // the grid while it is still out of view, settles the GA4 mirror events, and sends exposure when
  // the models grid is in view showing the flag's variant. No consent: A, never exposed.
  function peAB() {
    var KEY = 'post-enquiry-variant', CK = 'cl_pe';
    var root = document.documentElement;
    // Observe the first model card, not the section: the section is taller than the viewport, so a
    // ratio threshold on it would never be reached.
    var block = document.querySelector('.cl-pe .cl-pe__grid > li') || document.querySelector('.cl-pe');
    if (!block || !window.__clPe || window.__clPe === 'off') return;
    var mode = window.__clPeMode;
    if (mode !== 'test' && mode !== 'qa') return;
    var qa = mode === 'qa';
    if (qa) props.is_test_traffic = true;
    var toVar = { control: 'a', 'add-to-cart': 'b' }, toFlag = { a: 'control', b: 'add-to-cart' };
    var flagV = null, inView = false, exposed = false, frozen = false;
    function shown() { return root.getAttribute('data-pe') === 'b' ? 'b' : 'a'; }
    function settle(v) { if (window.__clPeSettle) window.__clPeSettle(v); }
    function setCookie(v) {
      if (v) document.cookie = CK + '=' + v + '; path=/; max-age=' + 60 * 60 * 24 * 30 + '; SameSite=Lax';
      else document.cookie = CK + '=; path=/; max-age=0; SameSite=Lax';
    }
    function apply(v) {
      if (frozen) return;
      window.__clPe = v; root.setAttribute('data-pe', v);
    }
    function expose() {
      if (exposed || !inView || !flagV || !ph || !consentState.analytics) return;
      if (shown() !== flagV) return;
      exposed = true;
      ph.capture('$feature_flag_called', { $feature_flag: KEY, $feature_flag_response: toFlag[flagV], ab_qa_override: qa || undefined, pe_variant: flagV.toUpperCase() });
    }
    function resolve() {
      if (!ph) return;
      if (qa) { flagV = shown(); ph.register({ is_test_traffic: true }); expose(); return; }
      if (!consentState.analytics) { flagV = null; setCookie(''); if (!inView) apply('a'); if (consentState.decided) settle('a'); return; }
      var raw = ph.getFeatureFlag(KEY, { send_event: false });
      var v = toVar[raw];
      if (v) {
        flagV = v; setCookie(v);
        if (!inView || shown() === v) apply(v); else frozen = true;
        settle(shown());
      } else if (raw !== undefined) {
        flagV = null; setCookie(''); if (!inView) apply('a'); settle('a');
      }
      expose();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es, obs) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          inView = true;
          if (!flagV && !qa) frozen = true;
          expose();
          if (exposed) obs.disconnect();
        });
      }, { threshold: 0.5 }).observe(block);
    }
    var tries = 0;
    (function wait() {
      if (ph) {
        if (props.market) try { ph.setPersonPropertiesForFlags({ market: props.market, store: props.store }); } catch (e) { /* old sdk */ }
        if (typeof ph.onFeatureFlags === 'function') ph.onFeatureFlags(resolve);
        resolve();
        ['CookiebotOnAccept', 'CookiebotOnDecline'].forEach(function (n) { window.addEventListener(n, function () { setTimeout(resolve, 300); }); });
        document.addEventListener('visitorConsentCollected', function () { setTimeout(resolve, 300); });
        return;
      }
      if (tries++ < 60) setTimeout(wait, 500);
    })();
  }

  /* --------------------------------------------------------------- start */
  window.clPH = {
    track: track,
    consent: function () { return consentState; },
    instance: function () { return ph; }
  };

  watchConsent();
  function onReady() { pageEvents(); if (props.template_suffix === 'black-friday') bfPriceAB(); if (document.querySelector('.cl-pe')) peAB(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady, { once: true });
  else onReady();
  whenIdle(loadSDK);
})();
